import { Button } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
interface FilterButtonProps {
  filters: boolean;
  setFilters: (value: boolean) => void;
   height?: number;
}

const FilterButton = ({ filters, setFilters, height }: FilterButtonProps) => {
  return (
    <Button
      variant="outlined"
      startIcon={<TuneIcon />}
      onClick={() => setFilters(!filters)}
      style={{
        border: '1px solid rgba(36, 76, 132, 1)',
         height: height || 23,
        fontFamily: 'Inter',
        fontSize: '14px',
        fontWeight: 700,
        color: '#2F4B82',
        backgroundColor: 'white',
        textTransform: 'none',
        padding: '8px',
        minWidth: '40px',
        marginTop: '0.5px'
      }}
    >
      {/* Filter */}
    </Button>
  );
};

export default FilterButton;
